import { IAnswerOption, IMaterialHeader, MaterialType } from '../../api/private/learn-engine-api/learn-engine-api.interface';
import { Ratings } from '../../api/public/ai-chat-api';
import { ICode } from '../../api/public/code-assistant';

export enum CloseAISolutionsClickSource {
	BackToCode = 'BACK_TO_CODE',
	Hide = 'HIDE',
	Outside = 'OUTSIDE',
}

export enum GetSolutionClickSource {
	AskAgain = 'ASK_AGAIN',
	TryAgain = 'TRY_AGAIN',
	Expand = 'EXPAND',
}

export enum SolutionClickType {
	ANIMATION = 'ANIMATION',
	AnimationClose = 'ANIMATION_CLOSE',
	ExplainTheCode = 'EXPLAIN THE CODE',
	FindTheBug = 'FIND THE BUG',
	Hint = 'HINT',
	CCSolution = 'CC SOLUTION',
	AlternativeExplanation = 'ALTERNATIVE EXPLANATION',
	RealLifeExamples = 'REAL-LIFE EXAMPLES',
	QuizHint = 'QUIZ HINT',
}

export interface IAction {
	type: ActionType;
	requestType?: RequestType;
	data?: IActionData;
}

export enum ActionType {
	// UI events
	OnMessageSubmitButtonClick,
	OnAIChatMount,
	OnExpandClick,
	OnHideClick,
	OnRateClick,
	CourseClick,
	OnAISolutionsMount,
	OnAISolutionClick,
	OnAISolutionRate,
	OnAISolutionCollapse,
	OnAISolutionsDataUpdate,
	OnAISolutionsClose,
	OnAISolutionsOpen,
	OnGetAIResponseInBottomSheetClick,
	OnAISolutionResponseCopy,

	// Business actions
	GetAIResponse,
}

export enum RequestType {
	Parallel,
	Cancelable,
	Sequential,
}

export enum ChatViewState {
	Closed = 'closed',
	Extended = 'extended',
	Full = 'full',
}

export enum ImpressionSource {
	Homepage = 'HOMEPAGE',
	LandingPage = 'LANDINGPAGE',
	Profile = 'PROFILE',
	Kodie = 'KODIE',
	Other = 'OTHER',
}

export interface IActionData {
	userMessage?: string;
	initialChatViewState?: ChatViewState;
	systemPromptId?: string;
	rating?: Ratings;
	messageId?: string;
	alias?: string;
	materialType?: MaterialType;
	actionId?: number;
	solutionType?: number;
	solutionRating?: number;
	materialHeader?: IMaterialHeader;
	solutionId?: string;
	codes?: ICode[];
	problem?: string;
	session?: string;
	getSolutionClickSource?: GetSolutionClickSource;
	closeAISolutionsClickSource?: CloseAISolutionsClickSource;
	solution?: ISolution;
	questionData?: IQuestionData;
	answerExplanationData?: IAnswerExplanationData;
	lessonContent?: string;
	courseName?: string;
	solutionContext?: number;
}

export enum Role {
	Assistant = 'assistant',
	User = 'user',
	Predefined = 'predefined',
}

export interface IMessages {
	role: Role;
	message: string;
	id?: string;
	rating?: number;
	aliases?: string[];
	usage?: {
		completionTokens: number;
		promptTokens: number;
		totalTokens: number;
	};
}

export interface ICourseImages {
	[alias: string]: { iconUrl: string; name: string };
}

export interface ISolutionData {
	id?: string;
	isSolution?: boolean;
	body: {
		type: number;
		language?: number;
		content: string;
	}[];
}

export interface ISolution {
	encryptedCode: string;
	languageId: number;
}

export interface IQuestionData {
	questionType: string;
	options: string[];
	content: string[];
}

export interface IAnswerExplanationData {
	question: string[];
	answer: string;
	isCorrect: boolean;
	answerOptions: IAnswerOption[];
	dynamicId: number;
}
